import { defineTool } from '@/shell/tool';

/** Charts: Vibes' chart builder in a frame (Flutter's `charts` embed). */
export default defineTool({
  id: 'vibes-charts',
  title: 'Charts',
  summary: "Vibes' chart builder, in a frame.",
  section: 'vibes',
  order: 70,
  icon: 'bar_chart',
  owner: '@Drabu',
  permission: 'vibes-charts:use',
  routes: () => import('./ChartsPage'),
});
